import { useTranslation } from "react-i18next"
import PageContainer from "../../../components/global/PageContainer"

const Users = () => {
  const { t } = useTranslation()

  return (
    <PageContainer
      title={t("total_users")}
      breadcrumbs={[
        { title: t("menu_overview"), path: "/overview" },
        { title: t("total_users") },
      ]}
      withFilters={false}
      withDatePicker={false}
      paddingTop={24}
    ></PageContainer>
  )
}

export default Users
